/**
 * Register Route
 *
 * Public registration route for email/password sign-up.
 * Delegates UI rendering to RegisterPage from FSD pages layer.
 *
 * @see .agents/skills/molchanovs-move-docs-tasks/references/source/task-DOC-0106.md
 */

import { createFileRoute } from '@tanstack/react-router';
import { RegisterPage } from '@pages/register';

export const Route = createFileRoute('/$locale/register')({
  component: RegisterRoute,
});

function RegisterRoute() {
  const { locale } = Route.useParams();
  return <RegisterPage locale={locale} />;
}
